import { PageBuilder } from '@portfolio/page-builder'
import { PageBuilderSection, PageResponse } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import { PasswordProtected } from '../PasswordProtected/PasswordProtected'

const SidebarPageLayout = styled('div', {
  position: 'relative',

  '@lg': {
    display: 'grid',
    gridTemplateColumns: 'minmax(0,1fr) minmax(0,2fr) minmax(0,.25fr)',
  },
})

const SidebarPageLayoutContainer = styled('div', {
  maxWidth: '$containerMaxWidthForSidebarLayout',
})

const PageWrapper = styled('div', {
  variants: {
    addBottomMargin: {
      true: {
        marginBottom: '$72',
        '@lg': {
          marginBottom: '$96',
        },
      },
    },
  },
})

export const DefaultPage = (args: PageResponse<PageBuilderSection>) => {
  const {
    headerSection,
    pageBuilder,
    sidebarSection,
    addBottomMargin,
    relatedArticles,
    isPasswordProtected = false,
    password = '',
    title,
    isVisuallyHiddenTitle,
  } = args

  const hiddenPageTitle = isVisuallyHiddenTitle ? (
    <h1 className="sr-only">{title}</h1>
  ) : null

  const headerElement = headerSection ? (
    <PageBuilder section={{ ...headerSection, priority: true }} />
  ) : null

  const sectionElements = pageBuilder?.map((section, index) => {
    return (
      <PageBuilder
        section={{ ...section, priority: index === 0 || index === 1 }}
        key={section._key || `section-${index}`}
      />
    )
  })

  if (!sidebarSection) {
    return (
      <PageWrapper
        addBottomMargin={isPasswordProtected ? false : addBottomMargin}
      >
        {hiddenPageTitle}
        {headerElement}
        <PasswordProtected
          password={password}
          isPasswordProtected={isPasswordProtected}
        >
          {sectionElements}
        </PasswordProtected>
      </PageWrapper>
    )
  } else {
    return (
      <PageWrapper
        addBottomMargin={isPasswordProtected ? false : addBottomMargin}
      >
        {hiddenPageTitle}
        {headerElement}
        <PasswordProtected
          password={password}
          isPasswordProtected={isPasswordProtected}
        >
          <div>
            <SidebarPageLayout>
              {sidebarSection && (
                <PageBuilder section={{ ...sidebarSection }} />
              )}
              <SidebarPageLayoutContainer>
                {sectionElements}
              </SidebarPageLayoutContainer>
              <div />
            </SidebarPageLayout>
            {relatedArticles && (
              <PageBuilder section={{ ...relatedArticles }} />
            )}
          </div>
        </PasswordProtected>
      </PageWrapper>
    )
  }
}
